export enum ResourceBoardType{
    HomePageResourceBoard=1,
    HomePageResourceSecondaryBoard=2,
    TicketsResourceBoard=3,
    TicketsResourceSecondaryBoard=4
}